var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 19.3L0 13.3L1.4 11.9L6 16.475L10.6 11.9L12 13.3L6 19.3ZM6 13.35L0 7.35L1.4 5.95L6 10.525L10.6 5.95L12 7.35L6 13.35ZM6 7.4L0 1.4L1.4 0L6 4.575L10.6 0L12 1.4L6 7.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageDown);
export default __webpack_public_path__ + "static/media/page-down.a4e9ef69f1b2b3c6104f4dc717805676.svg";
export { ForwardRef as ReactComponent };